/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EconomicPerformanceCalculationPurpose {
  Unknown = 0,
  Quotation = 10,
  CostControl = 20,
}
